import BgImage from './components/bg-image/bg-image.vue'
import vueResource from 'vue-resource'
Vue.use(vueResource);

Vue.http.headers.common['X-CSRF-TOKEN'] = window.Laravel.csrfToken;

Vue.directive('init', {
    bind: function (el, binding /*, vnode*/ ) {
        console.log(binding.value); //# This line is optional, of course.
    }
});

Vue.component('newsPage', {
    components: {
        BgImage
    },
    props: ['pagedata', '_perpage', '_limit', '_allitems'],
    data() {
        return {
            items: this.pagedata ? this.pagedata.items.data : [],
            categories: this.pagedata.categories ? this.pagedata.categories : [],
            allitems: this._allitems,
            limit: this._limit ? this._limit : 1,
            filters: {
                'year': null
            },
            perpage: this._perpage
        }
    },
    watch: {
        // whenever question changes, this function will run
        limit: function (newlimit, oldlimit) {
            this.alterGETparam('l', newlimit);
        }
    },
    computed: {
        filteredItems: function () {
            return this.items
                .filter(item => {
                    if (this.filters.year > 0) return item.year == this.filters.year;
                    else return item;
                });
        },
        filteredItemsLength: function () {
            return this.filteredItems.length;
        }
    },
    methods: {
        openFancybox(type, src) {
            $.fancybox.open({
                src: src,
                // type: type,
                opts: {
                    touch: false,
                    smallBtn: true,
                    btnTpl: {
                        smallBtn: `
                        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
                            <i class="icon-close"></i>
                        </button>`,
                    },
                }
            });
        },
        filterYear: function (value) {
            this.filters['year'] = value;
        },
        alterGETparam: function (param, value) {
            var clear = (typeof clear !== 'undefined') ? clear : false;
            var newURL = this.updateURLParameter(window.location.href, param, value);
            newURL = this.updateURLParameter(newURL, param, value);
            window.history.replaceState('', '', this.updateURLParameter(window.location.href, param, value));
        },

        updateURLParameter: function (url, param, paramVal) {
            var TheAnchor = null;
            var newAdditionalURL = "";
            var tempArray = url.split("?");
            var baseURL = tempArray[0];
            var additionalURL = tempArray[1];
            var temp = "";

            if (additionalURL) {
                var tmpAnchor = additionalURL.split("#");
                var TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];
                if (TheAnchor)
                    additionalURL = TheParams;

                tempArray = additionalURL.split("&");

                for (var i = 0; i < tempArray.length; i++) {
                    if (tempArray[i].split('=')[0] != param) {
                        newAdditionalURL += temp + tempArray[i];
                        temp = "&";
                    }
                }
            } else {
                var tmpAnchor = baseURL.split("#");
                var TheParams = tmpAnchor[0];
                TheAnchor = tmpAnchor[1];

                if (TheParams)
                    baseURL = TheParams;
            }

            if (TheAnchor)
                paramVal += "#" + TheAnchor;
            var rows_txt = temp + "" + param + "=" + paramVal;


            return baseURL + "?" + newAdditionalURL + rows_txt;
        },

        take_param: function (key) {
            var params = new Map(location.search.slice(1).split('&')
                .map(function (p) {
                    return p.split(/=(.*)/)
                }))
            var value = params.get(key)
            params.delete(key)
            var search = Array.from(params.entries()).map(
                function (v) {
                    return v[0] + '=' + v[1]
                }).join('&')
            return {
                search: search ? '?' + search : '',
                value: value
            }
        }
    },
    beforeCreate() {

    },
});


// WEBPACK FOOTER //
// ./src/js/news.js